import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  createEnquiry,
  updateFormField,
  submitPreAdmissionForm,
  resetForm,
  initialState,
  setError,
  clearError,
  error,
  clearSuccess,
} from "../../store/ApplicationEnquirySlice";
import { fetchBatches } from "../../store/AdmissionInformationSlice";

import { COUNTRIES } from "../../utils/countries";
import ErrorMessage from "../ErrorMessage";
import SuccessMessage from "../SuccessMessage";
const Enums = {
  Gender: [
    { value: 0, label: "Male" },
    { value: 1, label: "Female" },
  ],
  IncomeType: [
    { value: 0, label: "Salary" },
    { value: 1, label: "Business" },
    { value: 2, label: "Self Employed" },
    { value: 3, label: "Pension" },
    { value: 4, label: "Investment" },
    { value: 5, label: "Rental" },
    { value: 6, label: "Agriculture" },
    { value: 7, label: "Remittance" },
    { value: 8, label: "Other" },
  ],
  IncomeLevel: [
    { value: 0, label: "Low Income" },
    { value: 1, label: "Lower Middle Income" },
    { value: 2, label: "Middle Income" },
    { value: 3, label: "Upper Middle Income" },
    { value: 4, label: "High Income" },
  ],
  SpecialNeeds: [
    { value: "", label: "Select Special Needs Status" },
    { value: "Yes", label: "Yes, Special Need Required" },
    { value: "No", label: "No, Special Need Not Required" },
  ],
  Curriculum: [
    { value: "0", label: "Select Curriculum" },
    { value: "1", label: "International IGCEs (British Curriculum)" },
    { value: "2", label: "IB curriculum" },
    { value: "3", label: "Ethiopian national curriculum" },
    { value: "4", label: "Hybrid system" },
    { value: "5", label: "Other curriculum" },
  ],
};
const ApplicationEnquiryForm = ({ isStaff, isParent }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  console.log("isParent", isParent);
  const { isAuthenticated } = useSelector((state) => state.auth);
  const [errorMessage, setErrorMessage] = useState("");
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [imagePath, setImagePath] = useState({
    PreviousSchoolReportCard: "",
    YellowCardPhoto: "",
  });

  const [imagePreviews, setImagePreviews] = useState({
    PreviousSchoolReportCard: null,
    YellowCardPhoto: null,
  });

  const [base64Strings, setBase64Strings] = useState({
    PreviousSchoolReportCard: "",
    YellowCardPhoto: "",
  });

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isFileInputEnabled, setIsFileInputEnabled] = useState(false);
  const [view, setView] = useState(false);
  const [validatedBatches, setValidatedBatches] = useState([]);
  const {
    validatedBatchesForExistingParent,
    validatedBatchesForStaffs,
    validatedBatchesForNewParent,
    loading,
    error,
  } = useSelector((state) => state.admissionInformation.batches);
  const {
    formData = initialState.formData,
    status = "idle",
    successMessage = null,
  } = useSelector((state) => state.applicationEnquiry || {});
  useEffect(() => {
    dispatch(fetchBatches());
  }, [dispatch]);

  useEffect(() => {
    console.log("isStaff", isStaff);
    if (isAuthenticated) {
      if (isStaff && isParent) {
        const merged = [
          ...new Set([
            ...validatedBatchesForStaffs,
            ...validatedBatchesForExistingParent,
          ]),
        ];
        setValidatedBatches(merged);
        console.log("merged validatedBatches (Staff + Parent)", merged);
      } else if (isStaff) {
        setValidatedBatches(validatedBatchesForStaffs);
        console.log("validatedBatchesForStaffs", validatedBatchesForStaffs);
      } else if (isParent) {
        console.log(
          "validatedBatchesForExistingParent",
          validatedBatchesForExistingParent,
        );
        setValidatedBatches(validatedBatchesForExistingParent);
      }
    } else {
      setValidatedBatches(validatedBatchesForNewParent);
    }
  }, [
    dispatch,
    isAuthenticated,
    isStaff,
    isParent,
    validatedBatchesForNewParent,
    validatedBatchesForExistingParent,
    validatedBatchesForStaffs,
  ]);

  useEffect(() => {
    // Enable file input only if previous school is not empty
    setIsFileInputEnabled(formData.PreviousSchool?.trim() !== "");
  }, [formData.PreviousSchool]);

  useEffect(() => {
    // Show Yellow Card / Residence Permit upload for non-Ethiopian nationalities
    const shouldShowYellowCardUpload =
      formData.Nationality && formData.Nationality !== "Ethiopia";
    setView(Boolean(shouldShowYellowCardUpload));
  }, [formData.Nationality]);
  const handleBackHome = () => {
    if (isAuthenticated) {
      navigate("/dashboard");
    } else {
      navigate("/homepage");
    }
  };

  const handleInputChange = (e) => {
    // Defensive check for event and target
    if (!e || !e.target) {
      console.error("Invalid event object", e);
      return;
    }
    const { name, value } = e.target;

    // Special handling for curriculum to map to curriculumType
    if (name === "Curriculum") {
      dispatch(
        updateFormField({
          name: "CurriculumType",
          value: parseInt(value),
        }),
      );
    }

    // Defensive check for previousSchool
    if (name === "PreviousSchool" && typeof value === "string") {
      setIsFileInputEnabled(value.trim() !== "");
    }

    // Reset success modal
    if (isSuccessModalOpen) {
      setIsSuccessModalOpen(false);
    }

    // Dispatch form field update
    dispatch(updateFormField({ name, value }));
  };
  const handleBatchChange = (e) => {
    const selectedBatchValue = e.target.value;

    const selectedBatch = validatedBatches.find(
      (batch) =>
        `${batch.batchName} - ${batch.schoolName}` === selectedBatchValue,
    );
    if (selectedBatch) {
      dispatch(
        updateFormField({
          name: "BatchName",
          value: selectedBatch.batchName,
        }),
      );
      dispatch(
        updateFormField({
          name: "selectedAdmissionWindowId",
          value: selectedBatch.admissionWindowId,
        }),
      );

      dispatch(
        updateFormField({ name: "BatchYear", value: selectedBatch.batchId }),
      );

      dispatch(
        updateFormField({
          name: "SchoolName",
          value: selectedBatch.schoolName,
        }),
      );
      dispatch(
        updateFormField({
          name: "RequestedSchool",
          value: selectedBatch.schoolName,
        }),
      );
    } else {
      dispatch(updateFormField({ name: "BatchYear", value: "" }));
      dispatch(updateFormField({ name: "BatchYear", value: "" }));
      dispatch(updateFormField({ name: "BatchName", value: "" }));
      dispatch(updateFormField({ name: "SchoolName", value: "" }));
      dispatch(updateFormField({ name: "RequestedSchool", value: "" }));
    }
  };
  const handleFileChange = (event, fieldName) => {
    const file = event.target.files[0];

    if (file) {
      setImagePath((prev) => ({
        ...prev,
        [fieldName]: file.name,
      }));
      dispatch(updateFormField({ name: fieldName, value: file.name }));
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreviews((prevState) => ({
          ...prevState,
          [fieldName]: reader.result,
        }));
        setBase64Strings((prevState) => ({
          ...prevState,
          [fieldName]: reader.result.split(",")[1], // Save only the Base64 part
        }));
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate required fields
    const requiredFields = [
      "FirstName",
      "LastName",
      "SurName",
      "Gender",
      "DOB",
      "Nationality",
      "SpecialNeeds",
      "PhoneNumber",
      "IncomeType",
      "IncomeLevel",
      "RequestedSchool",
      "BatchName",
      "ContactEmail",
      "selectedAdmissionWindowId",
    ];
    console.log("formData is: ", formData);
    const missingFields = requiredFields.filter(
      (field) => !formData[field] || formData[field].toString().trim() === "",
    );
    console.log("missingFields are: ", missingFields);

    if (missingFields.length > 0) {
      dispatch(
        setError(`Missing required fields: ${missingFields.join(", ")}`),
      );
      setIsModalOpen(true);
      return;
    }
    try {
      console.log("calling createEnquiry", base64Strings);
      const response = await dispatch(
        createEnquiry({ formData, base64Strings }),
      );

      if (createEnquiry.fulfilled.match(response)) {
        setIsSuccessModalOpen(true); // ✅ Modal opens and stays open
      } else {
        // Display the error message if it's not successful
        setIsModalOpen(true);
        console.log("response", response);
        setErrorMessage(response.payload || "An error occurred.");
      }
    } catch (error) {
      setErrorMessage("An unexpected error occurred.");
    }
  };

  const closeModal = () => {
    dispatch(clearError()); // Clear the error in Redux
    setIsModalOpen(false); // Close the modal
  };
  const closeSuccessModal = () => {
    dispatch(clearSuccess()); // Clear the success message in Redux
    setIsSuccessModalOpen(false); // Close the success modal
  };

  useEffect(() => {
    if (status === "succeeded") {
      // alert('Application submitted successfully!');
      setIsSuccessModalOpen(true);
      dispatch(resetForm());
    } else if (status === "failed" && error) {
      const errorMessage = error.includes("<!DOCTYPE")
        ? "Server error. Please try again later."
        : error;
      // alert('Error submitting form: ' + errorMessage);
      dispatch(setError(errorMessage));
    }
  }, [status, error, dispatch, formData, handleInputChange]);

  const inputStyle =
    "mt-1 block w-full rounded-lg border border-gray-300 px-4 py-3 shadow-sm focus:outline-none focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/30 focus:shadow-[0_0_0_1px_rgba(99,102,241,0.2)] transition-all duration-300 ease-in-out text-gray-900 placeholder-gray-400 bg-white hover:border-indigo-300";
  const labelStyle = "block text-sm font-medium text-gray-700 mb-1";
  const fileInputStyle =
    "mt-1 block w-full text-sm text-gray-500 file:mr-4 file:py-3 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-indigo-50 file:text-indigo-700 hover:file:bg-indigo-100 hover:file:text-indigo-800 transition-all duration-300 ease-in-out cursor-pointer focus:outline-none";
  const selectStyle = inputStyle + " cursor-pointer";
  /*   const closeModal = () => {
    setIsModalOpen(false); // Close the modal
  }; */

  return (
    <div className="flex">
      <ErrorMessage
        isOpen={Boolean(errorMessage)}
        message={errorMessage}
        onClose={closeModal}
      />
      <SuccessMessage
        isOpen={isSuccessModalOpen}
        message={"Success"}
        onClose={() => setIsSuccessModalOpen(false)}
      />

      <div className="container mx-auto px-4 py-8 flex-1">
        <div className="text-center mb-4">
          <h1 className="text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-purple-600 mb-4">
            Join AIS
          </h1>
          <p className="text-xl text-gray-600">
            Take the first step towards your future in technology
          </p>
        </div>
        <div className="bg-white shadow-xl rounded-2xl overflow-hidden border border-gray-100 mx-auto">
          <div className="p-2">
            <form className="space-y-4" onSubmit={handleSubmit}>
              {/* Personal Information Section */}
              <div className="bg-white p-4 rounded-xl transition-all duration-300 hover:shadow-md">
                <div className="bg-white p-2 justify-center rounded-xl transition-all duration-300 hover:shadow-md">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center justify-center">
                    {" "}
                    {/* Added justify-center here */}
                    <span className="w-8 h-8 rounded-full bg-indigo-100 text-indigo-600 mr-3 flex items-center justify-center">
                      <svg
                        className="w-5 h-5"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                        />
                      </svg>
                    </span>
                    Student (The applicant) Basic Information
                  </h2>
                  <h4 className="text-center text-blue-600 mb-4">
                    {" "}
                    {/* Added text-center class here */}
                    More information would be requested later when accepted
                  </h4>
                </div>

                <div className="grid grid-cols-1 gap-6 md:grid-cols-2 w-3/5 mx-auto">
                  {" "}
                  {/* Centered and 60% width */}
                  <div>
                    <label className={labelStyle}>First Name *</label>
                    <input
                      type="text"
                      name="FirstName"
                      value={formData.FirstName}
                      onChange={handleInputChange}
                      required
                      className={inputStyle}
                      placeholder="Enter your first name"
                    />
                  </div>
                  <div>
                    <label className={labelStyle}>
                      Middle Name / Father Name *
                    </label>
                    <input
                      type="text"
                      name="SurName"
                      value={formData.SurName}
                      onChange={handleInputChange}
                      required
                      className={inputStyle}
                      placeholder="Enter your middle Father name"
                    />
                  </div>
                  <div>
                    <label className={labelStyle}>
                      Last Name/Grand Father Name *
                    </label>
                    <input
                      type="text"
                      name="LastName"
                      value={formData.LastName}
                      onChange={handleInputChange}
                      required
                      className={inputStyle}
                      placeholder="Enter your Grand Father Name"
                    />
                  </div>
                  <div>
                    <label className={labelStyle}>Gender *</label>
                    <select
                      name="Gender"
                      value={formData.Gender}
                      onChange={handleInputChange}
                      required
                      className={selectStyle}
                    >
                      <option value="">Select gender</option>
                      {Enums.Gender.map((gender) => (
                        <option key={gender.value} value={gender.value}>
                          {gender.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label className={labelStyle}>Date of Birth *</label>
                    <input
                      type="date"
                      name="DOB"
                      value={formData.DOB}
                      onChange={handleInputChange}
                      required
                      className={inputStyle}
                      max={new Date().toISOString().split("T")[0]} // Prevent future dates
                    />
                  </div>
                  <div>
                    <label className={labelStyle}>Nationality *</label>
                    <select
                      name="Nationality"
                      defaultValue=""
                      onChange={handleInputChange}
                      required
                      className={selectStyle}
                    >
                      <option value="" disabled>
                        Select Nationality
                      </option>
                      {COUNTRIES &&
                        COUNTRIES.map((country) => (
                          <option key={country} value={country}>
                            {country}
                          </option>
                        ))}
                    </select>
                  </div>
                  <div className="mb-4">
                    <label className={labelStyle}>
                      *Select grade level applying for
                    </label>
                    <select
                      name="BatchYear"
                      className={selectStyle}
                      onChange={handleBatchChange}
                      value={
                        formData.BatchName
                          ? `${formData.BatchName} - ${formData.SchoolName}`
                          : ""
                      }
                    >
                      <option value="">Select Year</option>
                      {[...validatedBatches]
                        .sort((a, b) => a.batchName.localeCompare(b.batchName))
                        .map((batch) => (
                          <option
                            key={batch.batchId}
                            value={`${batch.batchName} - ${batch.schoolName}`}
                          >
                            {`${batch.batchName} - ${batch.schoolName}`}
                          </option>
                        ))}
                    </select>
                    <label className={labelStyle + " mt-2"}></label>
                    <input
                      type="text"
                      value={formData.selectedAdmissionWindowId}
                      name="selectedAdmissionWindowId"
                      placeholder="selected admission window"
                      readOnly
                      className="hidden"
                    />
                  </div>
                  <div className="mb-4">
                    <label className={labelStyle}>
                      Previous School * (Leave blank if not applicable)
                    </label>
                    <input
                      type="text"
                      name="PreviousSchool"
                      value={formData.PreviousSchool}
                      onChange={handleInputChange}
                      className={inputStyle}
                      placeholder="Enter previous school name"
                    />
                  </div>
                  <div className="mb-4">
                    <label className={labelStyle}>
                      Curriculum (if previous school is selected)
                    </label>
                    <select
                      name="Curriculum"
                      value={formData.Curriculum}
                      onChange={handleInputChange}
                      disabled={!formData.PreviousSchool}
                      className={`${selectStyle} ${
                        !formData.PreviousSchool
                          ? "opacity-50 cursor-not-allowed"
                          : ""
                      }`}
                    >
                      {Enums.Curriculum.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="mb-4">
                    <label className={labelStyle}>
                      Prev Report Card (if previous school is selected)
                    </label>
                    <input
                      type="file"
                      name="PreviousSchoolReportCard"
                      onChange={(e) =>
                        handleFileChange(e, "PreviousSchoolReportCard")
                      }
                      disabled={!isFileInputEnabled}
                      accept=".pdf,.jpg,.jpeg,.png"
                      className={`mt-1 block w-full text-sm text-gray-500 file:mr-4 file:py-3 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold transition-all duration-300 ease-in-out ${
                        isFileInputEnabled
                          ? "file:text-indigo-700 hover:file:bg-indigo-100 hover:file:text-indigo-800 file:bg-indigo-50 cursor-pointer"
                          : "bg-white cursor-not-allowed focus:outline-none"
                      }`}
                    />
                    {formData.PreviousSchoolReportCard && (
                      <p className="mt-2">
                        {formData.PreviousSchoolReportCard}
                      </p>
                    )}
                    {imagePreviews.PreviousSchoolReportCard && (
                      <img
                        src={imagePreviews.PreviousSchoolReportCard}
                        alt="Previous School Report Card"
                        className="mt-4 w-full h-auto"
                      />
                    )}
                  </div>
                  <div className="mb-4">
                    <label className={labelStyle}>
                      Special Needs *(refers to inclusive education)
                    </label>
                    <select
                      name="SpecialNeeds"
                      value={formData.SpecialNeeds}
                      onChange={handleInputChange}
                      required
                      className={selectStyle}
                    >
                      {Enums.SpecialNeeds.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              {/* Contact Information Section */}
              <div className="bg-white p-6 rounded-xl transition-all duration-300 hover:shadow-md">
                <div className="bg-white p-6 rounded-xl transition-all duration-300 hover:shadow-md">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center justify-center">
                    {" "}
                    {/* Added justify-center */}
                    <span className="w-8 h-8 rounded-full bg-indigo-100 text-indigo-600 mr-3 flex items-center justify-center">
                      <svg
                        className="w-5 h-5"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                        />
                      </svg>
                    </span>
                    The Applicant Parent Basic Information
                  </h2>

                  {/* Center the following line */}
                  {isAuthenticated ? (
                    <h4 className="text-center text-blue-600">
                      {" "}
                      {/* Added text-center class */}
                      You don't need to fill applicant's parent information.
                    </h4>
                  ) : (
                    <h4 className="text-center text-green-600">
                      {" "}
                      {/* Added text-center class */}
                      More information would be requested later when accepted
                    </h4>
                  )}
                </div>
                <div className="grid grid-cols-1 gap-6 md:grid-cols-2 w-3/5 mx-auto">
                  {" "}
                  {/* Centered and 60% width */}
                  <div>
                    <label className={labelStyle}>
                      Contact Email Address *
                    </label>
                    <input
                      type="email"
                      name="ContactEmail"
                      value={formData.ContactEmail}
                      onChange={handleInputChange}
                      readOnly={isAuthenticated}
                      required
                      className={inputStyle}
                      placeholder="you@example.com"
                    />
                  </div>
                  <div>
                    <label className={labelStyle}>Phone Number *</label>
                    <input
                      type="tel"
                      name="PhoneNumber"
                      value={formData.PhoneNumber}
                      onChange={handleInputChange}
                      readOnly={isAuthenticated}
                      required
                      className={inputStyle}
                      placeholder="Enter your phone number"
                    />
                  </div>
                  <div className="mb-4">
                    <label className={labelStyle}>
                      Parent Valid ID card/ Yellow Card / Residence Permit/ Work
                      Permit
                    </label>
                    <input
                      type="file"
                      name="YellowCardPhoto"
                      onChange={(e) => handleFileChange(e, "YellowCardPhoto")}
                      disabled={!view}
                      accept=".pdf,.jpg,.jpeg,.png"
                      className={`mt-1 block w-full text-sm text-gray-500 file:mr-4 file:py-3 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold transition-all duration-300 ease-in-out ${
                        view
                          ? "file:text-indigo-700 hover:file:bg-indigo-100 hover:file:text-indigo-800 file:bg-indigo-50 cursor-pointer"
                          : "bg-white cursor-not-allowed focus:outline-none"
                      }`}
                    />
                    {formData.YellowCardPhoto && (
                      <p className="mt-2">{formData.YellowCardPhoto}</p>
                    )}
                    {imagePreviews.YellowCardPhoto && (
                      <img
                        src={imagePreviews.YellowCardPhoto}
                        alt="Yellow Card"
                        className="mt-4 w-full h-auto"
                      />
                    )}
                    <p
                      className={`mt-1 text-sm ${
                        view ? "text-gray-500" : "text-gray-300"
                      }`}
                    >
                      Upload your Files (Only for foreigners)
                    </p>
                  </div>
                  <div>
                    <label className={labelStyle}>Income Type *</label>
                    <select
                      name="IncomeType"
                      value={formData.IncomeType}
                      onChange={handleInputChange}
                      disabled={isAuthenticated}
                      required
                      className={selectStyle}
                    >
                      <option value="">Select income type</option>
                      {Enums.IncomeType.map((type) => (
                        <option key={type.value} value={type.value}>
                          {type.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label className={labelStyle}>Income Level *</label>
                    <select
                      name="IncomeLevel"
                      value={formData.IncomeLevel}
                      onChange={handleInputChange}
                      disabled={isAuthenticated}
                      required
                      className={selectStyle}
                    >
                      <option value="">Select income level</option>
                      {Enums.IncomeLevel.map((level) => (
                        <option key={level.value} value={level.value}>
                          {level.label}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              <div className="flex justify-between gap-4 mt-6">
                <button
                  type="button"
                  onClick={handleBackHome}
                  className="w-1/2 py-4 px-6 bg-blue-200 text-blue-800 font-semibold rounded-lg shadow-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 transition-all duration-300 transform hover:-translate-y-0.5"
                >
                  Back Home
                </button>

                <button
                  type="submit"
                  disabled={status === "loading"}
                  className="w-1/2 py-4 px-6 bg-gradient-to-r from-indigo-600 to-purple-600 text-white font-semibold rounded-lg shadow-md hover:from-indigo-700 hover:to-purple-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 transition-all duration-300 transform hover:-translate-y-0.5 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {status === "loading" ? (
                    <div className="flex items-center justify-center">
                      <svg
                        className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        ></circle>
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        ></path>
                      </svg>
                      Submitting...
                    </div>
                  ) : (
                    "Submit Application"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApplicationEnquiryForm;
